export const GET_TEAM_LINK_INFO = "get_team_link_info";
export const GET_TEAM_LINK_INFO_SUCCESS = "get_team_link_info_success";
